import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function useAddTask(reset) {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.PROJECT_TASK_API,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        reset({});
        SuccessToast({ text: data?.message });
        queryClient.invalidateQueries('get-all-buckets');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
